import React from "react";
import SeoMetadata from "./SeoMetadata";
import './App.css';
import Navbar from "./components/Navbar/Navbar";
import Home from './components/Pages/HomePage/Home';
import {BrowserRouter as Router, Switch, Route} from "react-router-dom";
import Footer from "./components/Footer/Footer";
import ImmunoClustDemo from "./components/Pages/ImmunoClustDemoPage/ImmunoClustDemo";
import LegalNotice from "./components/Pages/LegalNotice/LegalNotice";
import PrivacyPolice from "./components/Pages/PrivacyPolice/PrivacyPolice";
import About from "./components/Pages/About/About";
import Publications from "./components/Pages/Publications/Publications";
import {ConsentProvider} from "./ConsentContext";
import ConsentBanner from "./ConsentBanner";




function App() {
    return (
        <ConsentProvider>
            <ConsentBanner/>
            <Router>
                <SeoMetadata/>
                <Navbar/>
                <Switch>
                    <Route path='/' exact component={Home}/>
                    <Route path='/immunoclust-demo' exact component={ImmunoClustDemo}/>
                    <Route path='/legal-notice' exact component={LegalNotice}/>
                    <Route path='/privacy' exact component={PrivacyPolice}/>
                    <Route path='/about' exact component={About}/>
                    <Route path='/publications' exact component={Publications}/>
                </Switch>
                <Footer/>
            </Router>
        </ConsentProvider>
    );
}

export default App;
